import React from "react";

function DiagonalRackPattern() {
  return (
    <div
      className="relative overflow-hidden rounded-md border border-zinc-700/50 px-3 py-2 flex-1"
      style={{
        backgroundColor: "#18181b",
        backgroundImage: `
          repeating-linear-gradient(
            0deg,
            transparent,
            transparent 5px,
            #3f3f46 5px,
            #3f3f46 6px
          ),
          repeating-linear-gradient(
            60deg,
            transparent,
            transparent 5px,
            #3f3f46 5px,
            #3f3f46 6px
          ),
          repeating-linear-gradient(
            120deg,
            transparent,
            transparent 5px,
            #3f3f46 5px,
            #3f3f46 6px
          )
        `,
        boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.5)",
      }}
    >
      {/* Top highlight for 3D effect */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-zinc-500/40"></div>
    </div>
  );
}

export default DiagonalRackPattern;
